import { ProjectElementNode } from '@deltek/specification-client/core/Models/productListingDetail'
import { Theme, makeStyles } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton/Skeleton'
import React from 'react'
import ElementItemCard from './ElementsPanel/ElementItemCard'

export interface SustainabilityFamilyTreeListProps {
    sustanaibilityTopicFamilies?: ProjectElementNode[] | undefined
    loading?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
    loadSkeleton: {
        width: '95%',
        borderRadius: 4,
        backgroundColor: '#7288a3',
        marginBottom: 8,
        marginLeft: 12,
    },
}))

const SustainabilityFamilyTreeList: React.FC<SustainabilityFamilyTreeListProps> = ({
    sustanaibilityTopicFamilies,
    loading,
}) => {
    const classes = useStyles()

    if (loading) {
        return (
            <div>
                <div
                    style={{
                        opacity: 0.6,
                    }}
                >
                    <Skeleton
                        variant="rect"
                        animation="pulse"
                        height={48}
                        className={classes.loadSkeleton}
                    />
                </div>
                <div
                    style={{
                        opacity: 0.4,
                    }}
                >
                    <Skeleton
                        variant="rect"
                        animation="pulse"
                        height={48}
                        className={classes.loadSkeleton}
                    />
                </div>
                <div
                    style={{
                        opacity: 0.2,
                    }}
                >
                    <Skeleton
                        variant="rect"
                        animation="pulse"
                        height={48}
                        className={classes.loadSkeleton}
                    />
                </div>
            </div>
        )
    } else {
        return (
            <div
                style={{
                    marginTop: 10,
                    width: 320,
                    alignItems: 'end',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        marginTop: 4,
                        width: 320,
                    }}
                >
                    {sustanaibilityTopicFamilies?.map(
                        (item: ProjectElementNode) => {
                            const titleArray = item.text.split('|')
                            return (
                                <ElementItemCard
                                    isSearchResult={false}
                                    title={titleArray[1]}
                                    subtitle={'Family ' + titleArray[0]}
                                    expanded={true}
                                    hasSubItems={false}
                                    disableExpand={false}
                                    isSelected={false}
                                    contentTeamFromStudioPage={true}
                                />
                            )
                        }
                    )}
                </div>
            </div>
        )
    }
}

export default SustainabilityFamilyTreeList
